import { RowCrudStatus } from "../../common/types";
import { SatelliteHeartbeat } from "../../../api/graphql";
import { LangStore } from "../../../store";
import { graphqlToDateTime } from "../../../common/utils";

export type SatelliteHeartbeatValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
};

export type SatelliteHeartbeatErrorsType = {};

export function SatelliteHeartbeatValuesInit(): SatelliteHeartbeatValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
  };
}

export type SatelliteHeartbeatType =
  | SatelliteHeartbeat
  | SatelliteHeartbeatValuesType;

export function satelliteHeartbeatDisplayId(
  source: Partial<SatelliteHeartbeat>,
  _langStore: LangStore
) {
  return (
    `${graphqlToDateTime(source.receivedAt)}` +
    (source.publicIp ?? _langStore.emptyStringSymbol)
  );
}

export function getSatelliteHeartbeatValues(
  source: SatelliteHeartbeatType,
  _langStore: LangStore,
  _duplicated: boolean = false
): SatelliteHeartbeatValuesType {
  const entityValues = SatelliteHeartbeatValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : satelliteHeartbeatDisplayId(source, _langStore);
  entityValues.version_ = source.version_;

  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
